export default {
  editor_chatTab_text_messagePlaceholderNamed: 'Mensagem {peer}',
  editor_chatTab_text_messagePlaceholder_meBot:
    'Envie mensagens para voc\u00ea mesmo',
  mediaTray_chatTab_notification_stickerMessage:
    'enviou um sticker - {stickerName} ',
};
